import Icon from 'veui/components/Icon'

Icon.register({
  'turn-90-cw': {
    paths: [
      {
        d: 'M160 644.53a31.91 31.91 0 01-22.4-9.15A352 352 0 11729 313.63 32 32 0 01689.69 351l-121.6-31a32 32 0 0115.82-62l66.71 17A287.55 287.55 0 00384 96a288 288 0 00-201.6 493.67 32 32 0 01-22.4 54.86zM565.5 519v108.78c-.48 24.05-8.13 42.86-22.74 56-14.25 12.92-31.76 19.6-52.06 19.84h-.12c-19.71-.24-36.93-6.9-51.17-19.81-15.33-13.18-23.22-32-23.45-56V519c.23-24.1 8.12-43 23.45-56.18 14.26-12.92 31.5-19.47 51.23-19.47 20.32 0 37.86 6.56 52.13 19.52C557.37 476 565 494.89 565.5 519zm-45 2.36c-.62-22-10.1-32.49-29.82-32.92-19.82.43-29.25 10.9-29.65 32.94v104.37c.4 22.18 9.83 32.65 29.65 32.87 19.72-.22 29.2-10.69 29.82-32.93zm-127.88-32c20 47.85-25.89 120.91-71.54 214.14h-51.5c12.62-24.65 35.2-70.09 51.53-103-73.27 11-98.76-84.46-54.2-132.72 34.62-36.36 106.49-33.12 125.71 21.58zm-101.93 26.77c-8.88 47 49.72 65 61.51 14.5 6.42-51.54-50.77-56.63-61.51-14.5zM672 432a48 48 0 11-48-48 48.05 48.05 0 0148 48zm-32 0a16 16 0 10-16 16 16 16 0 0016-16z'
      }
    ],
    width: '768',
    height: '768'
  }
})
